import React from 'react';
import {PropsWithChildren} from "react";
import Nav from "./Nav";

const rootStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
}

const mainStyle = {
  padding: '59px 0 0 83px',
  flex: '1',
  overflowY: 'auto',
}

export default function Layout({children}:PropsWithChildren<{}>) {
  return (
    <div style={rootStyle as React.CSSProperties}>
      <Nav />
      <main style={mainStyle as React.CSSProperties}>
        {children}
      </main>
    </div>
  )
}